import { ResponseClientExternalIdentity, RequestClientExternalIdentity } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { ClientExternalIdentityActions } from '../actions';
import { ClientExternalIdentityTypes } from '../../shared/enums';

export interface ClientExternalIdentityState {
    response: ResponseClientExternalIdentity;
    request: RequestClientExternalIdentity;
    error: any;
}

export const ClientExternalIdentityInitialState: ClientExternalIdentityState = {
    response: null,
    request: null,
    error: null
};

const _clientExternalIdentityReducer = createReducer(
    ClientExternalIdentityInitialState,

    on(ClientExternalIdentityActions.getClientExternalIdentity, (state, { request }) => ({
        ...state,
        request,
        error: null
    })),

    on(ClientExternalIdentityActions.getClientExternalIdentitySucess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(ClientExternalIdentityActions.getClientExternalIdentityError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(ClientExternalIdentityActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function clientExternalIdentityReducer(state, action) {
    if (action.type === ClientExternalIdentityTypes.CLIENT_EXTERNAL_IDENTITY) {
        state = undefined;
    }
    return _clientExternalIdentityReducer(state, action);
}
